export default function CritAirBadge({ level, size = "md" }) {
  if (!level) return <span className="text-zinc-500 text-sm">Non concerné</span>;
  const dim = size === "lg" ? "w-10 h-10 text-base" : "w-8 h-8 text-sm";
  return (
    <span
      data-testid="critair-badge"
      title={`Vignette Crit'Air ${level}`}
      className={`${dim} inline-flex items-center justify-center rounded-full border-2 border-[#FF1E27] bg-black font-display font-black text-white`}
    >
      <span className="text-[#FF1E27] mr-px text-[0.6em] align-top">C</span>
      {level}
    </span>
  );
}
